import { routesAuth, routesRegister } from '@views/auth';
import { routesEnvelope } from '@views/envelopes';
import { routesProfile } from '@views/profile';

import { IRoute } from '@common/Routing/types';

export const authRoutes: IRoute[] = [...routesAuth];
export const registerRoutes: IRoute[] = [...routesRegister];

export const privateRoutes: IRoute[] = [...routesEnvelope, ...routesProfile];
